module.exports = __webpack_public_path__ + "static/media/map-marker-edit.08b2a0aa.svg";